import { useMemo, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { api, ExamFormat } from "api";

export const useFilteredExams = () => {
  const { data: examDates, isFetching } = useQuery({
    queryKey: ["examDates"],
    queryFn: () => api.exams.getExamDates({}),
    select: (response) => response.data,
  });

  const [filters, setFilters] = useState<{
    examGroupId?: number;
    centreCode?: string;
    examFormat?: ExamFormat;
  }>({});

  const filteredRows = useMemo(
    () =>
      examDates?.filter(
        (x) =>
          (!filters.examGroupId || filters.examGroupId === x.examGroupId) &&
          (!filters.centreCode || filters.centreCode === x.centreCode) &&
          (!filters.examFormat || filters.examFormat === x.examFormat)
      ) ?? [],
    [examDates, filters.centreCode, filters.examFormat, filters.examGroupId]
  );

  return { rows: filteredRows, setFilters, filters, isFetching };
};
